import React from 'react';
import ChartistGraph from 'react-chartist';
import withStyles from '@material-ui/core/styles/withStyles';
import {
  Select, MenuItem, Grid, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
  InputAdornment, FormLabel
} from '@material-ui/core/';
import Typography from '@material-ui/core/Typography';
import { AccessTime, Lens, Visibility, } from '@material-ui/icons';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import { ArrowDown, Bolt, ThermometerQuarter } from '@styled-icons/fa-solid';

import Button from '../../../components/CustomButtons/Button';
import Card from '../../../components/Card/Card';
import CardHeader from '../../../components/Card/CardHeader';
import CardBody from '../../../components/Card/CardBody';
import CustomInput from '../../../components/CustomInput/CustomInput';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import ImageDropZone from '../../../components/ImageDropZone';

import {
  vibrationChart,
  multiLineChart,
  pressureChart,
  temparatureChart,
} from '../../../variables/charts';

import dashboardStyle from '../../../assets/jss/material-dashboard-react/views/dashboardStyle';


function PredictMaintainMonitoring() {
  const [issueStatus, setStatus] = React.useState('monitoring');
  const [open, setOpen] = React.useState(false);

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setStatus(event.target.value as string);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const FormDialog = (
    <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
      <DialogTitle id="create-work-order">New Work Order</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Grid container justify="center" alignItems="center" spacing={2}>
            <Grid item xs={6}>
              <CustomInput
                id="asset-id"
                labelText="Asset ID"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="asset-type"
                labelText="Asset Type"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="asset-location"
                labelText="Asset Location"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="asset-model"
                labelText="Asset Model"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <CustomInput
                id="work-description"
                multiline
                rowsMax={4}
                labelText="Work description"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="work-schedule"
                labelText="Work schedule"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <AccessTime />
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="repeating-schedule"
                labelText="Repeating schedule"
                inputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <AccessTime />
                    </InputAdornment>
                  )
                }}
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="estimate-completion-time"
                labelText="Estimated completion time"
                inputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <AccessTime />
                    </InputAdornment>
                  )
                }}
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormLabel>Priority </FormLabel>
              <ToggleButtonGroup
                size="small"
                exclusive
                aria-label="text alignment"
              >
                <ToggleButton value="None" aria-label="none">
                  None
                </ToggleButton>
                <ToggleButton value="low" aria-label="low">
                  Low
                </ToggleButton>
                <ToggleButton value="medium" aria-label="medium">
                  Medium
                </ToggleButton>
                <ToggleButton value="high" aria-label="high">
                  High
                </ToggleButton>
              </ToggleButtonGroup>
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="work-schedule"
                labelText="Work schedule"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <AccessTime />
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="repeating-schedule"
                labelText="Repeating schedule"
                inputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <AccessTime />
                    </InputAdornment>
                  )
                }}
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="estimate-completion-time"
                labelText="Estimated completion time"
                inputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <AccessTime />
                    </InputAdornment>
                  )
                }}
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="work-schedule"
                labelText="Work schedule"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <AccessTime />
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="assigned-to"
                labelText="Assigned To"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="assigned-team"
                labelText="Assigned Team"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <ImageDropZone />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="addtional"
                labelText="Add Additional"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
          </Grid>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Create
        </Button>
        <Button onClick={handleClose} color="secondary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );

  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div style={{ backgroundColor: "#fff", padding: "8px 24px" }}>
            <Grid container>
              <Grid container item xs={8} alignContent="center">
                <Select
                  value={issueStatus}
                  onChange={handleChange}
                  inputProps={{ 'aria-label': 'Without label' }}
                >
                  <MenuItem value="none">None</MenuItem>
                  <MenuItem value="monitoring">Monitoring</MenuItem>
                  <MenuItem value="done">Done</MenuItem>
                </Select>
                <span style={{ marginLeft: "24px" }}>HVAC - ASSET ID - 98977829 / MODEL - PDD2904</span>
              </Grid>
              <Grid container item xs={4} justify="flex-end">
                <Button color="secondary" onClick={handleOpen}>Create new work order</Button>
              </Grid>
            </Grid>
          </div>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={9} md={9}>
          <GridContainer>
            <GridItem xs={12} sm={6} md={3}>
              <Card>
                <CardHeader>
                  <div style={{ position: "absolute", right: "8px", top: "10px" }} >
                    <Visibility style={{ color: "gray", marginRight: "5px" }} fontSize="small" />
                    <Lens style={{ color: "green" }} fontSize="small" />
                  </div>
                  <Typography color="primary" variant="subtitle2">HVAC</Typography>
                </CardHeader>
                <CardBody>
                  <GridContainer>
                    <GridItem xs={6}>
                      <Typography variant="caption">Model</Typography>
                    </GridItem>
                    <GridItem xs={6}>
                      <Typography variant="caption">PD02894</Typography>
                    </GridItem>
                    <GridItem xs={6}>
                      <Typography variant="caption">ASSET ID</Typography>
                    </GridItem>
                    <GridItem xs={6}>
                      <Typography variant="caption">98977829</Typography>
                    </GridItem>
                    <GridItem xs={6}>
                      <Typography variant="caption">NO ISSUES</Typography>
                    </GridItem>
                    <GridItem xs={6}>
                      <Typography variant="caption">0.2571</Typography>
                    </GridItem>
                  </GridContainer>
                </CardBody>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={3}>
              <Card id="current" style={{ backgroundColor: "rgb(239, 239, 239)", border: "1px #ccc solid" }}>
                <CardHeader>
                  <div style={{ position: "absolute", right: "8px", top: "10px" }} >
                    <Visibility style={{ color: "gray", marginRight: "5px" }} fontSize="small" />
                    <Lens style={{ color: "red" }} fontSize="small" />
                  </div>
                  <Typography color="primary" variant="subtitle2">HVAC</Typography>
                </CardHeader>
                <CardBody>
                  <GridContainer>
                    <GridItem xs={6}>
                      <Typography variant="caption">Model</Typography>
                    </GridItem>
                    <GridItem xs={6}>
                      <Typography variant="caption">PD02904</Typography>
                    </GridItem>
                    <GridItem xs={6}>
                      <Typography variant="caption">ASSET ID</Typography>
                    </GridItem>
                    <GridItem xs={6}>
                      <Typography variant="caption">98977829</Typography>
                    </GridItem>
                    <GridItem xs={6}>
                      <Typography variant="caption">FAIL</Typography>
                    </GridItem>
                    <GridItem xs={6}>
                      <Typography variant="caption">0.9876</Typography>
                    </GridItem>
                  </GridContainer>
                </CardBody>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={3}>
              <Card>
                <CardHeader>
                  <div style={{ position: "absolute", right: "8px", top: "10px" }} >
                    <Visibility style={{ color: "gray", marginRight: "5px" }} fontSize="small" />
                    <Lens style={{ color: "orange" }} fontSize="small" />
                  </div>
                  <Typography color="primary" variant="subtitle2">HVAC</Typography>
                </CardHeader>
                <CardBody>
                  <GridContainer>
                    <GridItem xs={6}>
                      <Typography variant="caption">Model</Typography>
                    </GridItem>
                    <GridItem xs={6}>
                      <Typography variant="caption">PD02924</Typography>
                    </GridItem>
                    <GridItem xs={6}>
                      <Typography variant="caption">ASSET ID</Typography>
                    </GridItem>
                    <GridItem xs={6}>
                      <Typography variant="caption">98977829</Typography>
                    </GridItem>
                    <GridItem xs={6}>
                      <Typography variant="caption">MONITOR</Typography>
                    </GridItem>
                    <GridItem xs={6}>
                      <Typography variant="caption">0.4876</Typography>
                    </GridItem>
                  </GridContainer>
                </CardBody>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={3}>
              <Card>
                <CardHeader>
                  <div style={{ position: "absolute", right: "8px", top: "10px" }} >
                    <Visibility style={{ color: "gray", marginRight: "5px" }} fontSize="small" />
                    <Lens style={{ color: "green" }} fontSize="small" />
                  </div>
                  <Typography color="primary" variant="subtitle2">Cooling Tower</Typography>
                </CardHeader>
                <CardBody>
                  <GridContainer>
                    <GridItem xs={6}>
                      <Typography variant="caption">Model</Typography>
                    </GridItem>
                    <GridItem xs={6}>
                      <Typography variant="caption">PD02974</Typography>
                    </GridItem>
                    <GridItem xs={6}>
                      <Typography variant="caption">ASSET ID</Typography>
                    </GridItem>
                    <GridItem xs={6}>
                      <Typography variant="caption">98977829</Typography>
                    </GridItem>
                    <GridItem xs={6}>
                      <Typography variant="caption">NO ISSUES</Typography>
                    </GridItem>
                    <GridItem xs={6}>
                      <Typography variant="caption">0.1876</Typography>
                    </GridItem>
                  </GridContainer>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
      <GridContainer>
      </GridContainer>
      <Typography variant="h5">HVAC - ASSET ID - 98977829 / MODEL - PDD204 | Probability of Failure: <b>0.894</b></Typography>
      <GridContainer>
        <GridItem xs={12}>
          <div style={{ overflow: "scroll", display: "flex", gridTemplateColumns: "20px 1fr 20px" }}>
            <div style={{ width: "220px", marginRight: "16px" }}>
              <Card>
                <CardHeader>
                  <Typography color="primary" variant="caption">Inlet Temparature (°C)</Typography>
                </CardHeader>
                <CardBody>
                  <GridContainer justify="center" alignItems="center">
                    <GridItem>
                      <ThermometerQuarter size="20px" />
                      <span style={{ margin: "0 4px", fontWeight: "bold", fontSize: "18px" }}>36.69</span>
                      <Lens style={{ color: "green" }} fontSize="small" />
                    </GridItem>
                  </GridContainer>
                </CardBody>
              </Card>
            </div>
            <div style={{ width: "220px", marginRight: "16px" }}>
              <Card>
                <CardHeader>
                  <Typography color="primary" variant="caption">Inlet Pressure (Bars)</Typography>
                </CardHeader>
                <CardBody>
                  <GridContainer justify="center" alignItems="center">
                    <GridItem>
                      <ArrowDown size="20px" />
                      <span style={{ margin: "0 4px", fontWeight: "bold", fontSize: "18px" }}>1.289</span>
                      <Lens style={{ color: "orange" }} fontSize="small" />
                    </GridItem>
                  </GridContainer>
                </CardBody>
              </Card>
            </div>
            <div style={{ width: "220px", marginRight: "16px" }}>
              <Card>
                <CardHeader>
                  <Typography color="primary" variant="caption">Vibration (Hz)</Typography>
                </CardHeader>
                <CardBody>
                  <GridContainer justify="center" alignItems="center">
                    <GridItem>
                      <span style={{ margin: "0 4px 0 0", fontWeight: "bold", fontSize: "20px" }}>Hz</span>
                      <span style={{ margin: "0 4px", fontWeight: "bold", fontSize: "18px" }}>2.269</span>
                      <Lens style={{ color: "green" }} fontSize="small" />
                    </GridItem>
                  </GridContainer>
                </CardBody>
              </Card>
            </div>
            <div style={{ width: "220px", marginRight: "16px" }}>
              <Card>
                <CardHeader>
                  <Typography color="primary" variant="caption">Outlet Temparature (°C)</Typography>
                </CardHeader>
                <CardBody>
                  <GridContainer justify="center" alignItems="center">
                    <GridItem>
                      <ThermometerQuarter size="20px" />
                      <span style={{ margin: "0 4px", fontWeight: "bold", fontSize: "18px" }}>42.19</span>
                      <Lens style={{ color: "orange" }} fontSize="small" />
                    </GridItem>
                  </GridContainer>
                </CardBody>
              </Card>
            </div>
            <div style={{ width: "220px", marginRight: "16px" }}>
              <Card>
                <CardHeader>
                  <Typography color="primary" variant="caption">Outlet Pressure (Bars)</Typography>
                </CardHeader>
                <CardBody>
                  <GridContainer justify="center" alignItems="center">
                    <GridItem>
                      <ArrowDown size="20px" />
                      <span style={{ margin: "0 4px", fontWeight: "bold", fontSize: "18px" }}>1.389</span>
                      <Lens style={{ color: "red" }} fontSize="small" />
                    </GridItem>
                  </GridContainer>
                </CardBody>
              </Card>
            </div>
            <div style={{ width: "220px", marginRight: "16px" }}>
              <Card>
                <CardHeader>
                  <Typography color="primary" variant="caption">Power (Watt)</Typography>
                </CardHeader>
                <CardBody>
                  <GridContainer justify="center" alignItems="center">
                    <GridItem>
                      <Bolt size="20px" />
                      <span style={{ margin: "0 8px", fontWeight: "bold", fontSize: "18px" }}>3.89</span>
                      <Lens style={{ color: "green" }} fontSize="small" />
                    </GridItem>
                  </GridContainer>
                </CardBody>
              </Card>
            </div>
            <div style={{ width: "220px", marginRight: "16px" }}>
              <Card>
                <CardHeader>
                  <Typography color="primary" variant="caption">Remaining unused life</Typography>
                </CardHeader>
                <CardBody>
                  <GridContainer justify="center" alignItems="center">
                    <GridItem>
                      <span style={{ margin: "0 4px", fontWeight: "bold", fontSize: "18px" }}>122 day</span>
                    </GridItem>
                  </GridContainer>
                </CardBody>
              </Card>
            </div>
          </div>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader>
              <Typography variant="subtitle2" style={{ marginLeft: "32px", marginBottom: "16px" }}>Sensor Reading Prediction</Typography>
            </CardHeader>
            <CardBody>
              <ChartistGraph
                className="custom-chart"
                data={multiLineChart.data}
                type="Line"
                options={multiLineChart.options}
              //listener={dailySalesChart.animation}
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={4}>
          <Card>
            <CardHeader>
              <Typography variant="subtitle2" style={{ marginLeft: "32px", marginBottom: "16px" }}>Vibration (Hz)</Typography>
            </CardHeader>
            <CardBody>
              <ChartistGraph
                className="custom-chart"
                data={vibrationChart.data}
                type="Line"
                options={vibrationChart.options}
              //listener={dailySalesChart.animation}
              />
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
          <Card>
            <CardHeader>
              <Typography variant="subtitle2" style={{ marginLeft: "32px", marginBottom: "16px" }}>Outlet Temparature (°C)</Typography>
            </CardHeader>
            <CardBody>
              <ChartistGraph
                className="custom-chart"
                data={temparatureChart.data}
                type="Line"
                options={temparatureChart.options}
              //listener={dailySalesChart.animation}
              />
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
          <Card>
            <CardHeader>
              <Typography variant="subtitle2" style={{ marginLeft: "32px", marginBottom: "16px" }}>Outlet Pressure (Bar)</Typography>
            </CardHeader>
            <CardBody>
              <ChartistGraph
                className="custom-chart"
                data={pressureChart.data}
                type="Line"
                options={pressureChart.options}
              //listener={dailySalesChart.animation}
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      { FormDialog}
    </div >
  );
}

export default withStyles(dashboardStyle)(PredictMaintainMonitoring);
